import { createRoot, createSignal } from "solid-js"
import type { Texture } from "three"

type ImageLike = 
  | HTMLImageElement 
  | HTMLCanvasElement 
  | OffscreenCanvas 
  | Texture
  | { 
      name?: string; 
      img: HTMLImageElement | HTMLCanvasElement | OffscreenCanvas | Texture 
    }

export const [getDebugImageList, setDebugImageList] = createRoot(() => {
  // eslint-disable-next-line solid/reactivity
  return createSignal<Array<ImageLike>>([])
})
